import axios from "axios"
import { useAuthentication } from "@today/auth"
import useSWR, { Key, SWRConfiguration, SWRResponse } from "swr"
import useSWRInfinite, {
  SWRInfiniteConfiguration,
  SWRInfiniteResponse,
} from "swr/infinite"

export const SWR_AUTH_TOKEN_HEADER = "x-today-openapi-token"

export function useSWRWithAuth<Data, Error = any>(
  key: Key,
  config?: SWRConfiguration
): SWRResponse<Data, Error> {
  const { accessToken } = useAuthentication()
  // key가 falsy이면 null을 넘겨 조건부 fetch(스킵)를 유지한다.
  // 배열로 감싸면 [falsy, token]도 truthy 키가 되어 SWR이 요청을 스킵하지 못한다.
  return useSWR(key ? [key, accessToken] : null, {
    ...(config ?? {}),
    // SWR v2부터 배열 키는 fetcher에 spread되지 않고 배열 그대로 전달된다.
    fetcher: ([url, token]: [string, string]) =>
      axios
        .get(url, { headers: { [SWR_AUTH_TOKEN_HEADER]: token } })
        .then((res) => res.data),
  })
}

export function useSWRInfiniteWithAuth<Data, Error = any>(
  getKey: (index: number, previousPageData: Data) => Key,
  config?: SWRInfiniteConfiguration
): SWRInfiniteResponse<Data, Error> {
  const { accessToken } = useAuthentication()
  return useSWRInfinite(
    (index: number, previousPageData: Data) => {
      // getKey 결과가 falsy이면 null을 반환해 조건부 fetch(스킵)를 유지한다.
      const key = getKey(index, previousPageData)
      return key ? [key, accessToken] : null
    },
    {
      ...(config ?? { revalidateFirstPage: false }),
      // SWR v2부터 배열 키는 fetcher에 spread되지 않고 배열 그대로 전달된다.
      fetcher: ([url, token]: [string, string]) =>
        axios
          .get(url, { headers: { [SWR_AUTH_TOKEN_HEADER]: token } })
          .then((res) => {
            return res.data
          }),
    }
  )
}
